import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import authService from "../services/discordAuth";
import "./ReportModal.css"; // Reutilizando a estrutura de modal base

function UpdateBotModal({ isOpen, onClose, bot, onRefresh, editingUpdate }) {
  const { t } = useTranslation();
  const [version, setVersion] = React.useState("");
  const [title, setTitle] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [type, setType] = React.useState("improvement");
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");

  // Efeito para carregar dados se for edição
  React.useEffect(() => {
    if (editingUpdate) {
      setVersion(editingUpdate.version || "");
      setTitle(editingUpdate.title || "");
      setDescription(editingUpdate.description || "");
      setType(editingUpdate.type || "improvement");
    } else {
      setVersion("");
      setTitle("");
      setDescription("");
      setType("improvement");
    }
  }, [editingUpdate, isOpen]);

  if (!isOpen || !bot) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!version || !title || !description) {
      setError(t("bot_details.updates.modal.error_fill_all"));
      return;
    }

    setLoading(true);
    setError("");

    try {
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";
      const token = authService.getAccessToken();

      const url = editingUpdate ? `${BACKEND_URL}/api/bots/${bot.id}/updates/${editingUpdate.id}` : `${BACKEND_URL}/api/bots/${bot.id}/updates`;

      const method = editingUpdate ? "PUT" : "POST";

      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          version,
          title,
          description,
          type,
          is_public: 1,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        onRefresh();
        onClose();
        // Reset form
        if (!editingUpdate) {
          setVersion("");
          setTitle("");
          setDescription("");
          setType("improvement");
        }
      } else {
        setError(data.error || t("bot_details.updates.modal.error_generic"));
      }
    } catch (err) {
      console.error("Erro ao processar update:", err);
      setError(t("bot_details.updates.modal.error_generic"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content animation-scale-up" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>
            {editingUpdate ? "✏️" : "🚀"} {editingUpdate ? t("bot_details.updates.modal.title_edit", { name: bot.name }) : t("bot_details.updates.modal.title", { name: bot.name })}
          </h2>
          <button className="modal-close" onClick={onClose}>
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-body">
          {error && (
            <div
              className="error-message"
              style={{
                marginBottom: "1rem",
                color: "#ff4444",
                background: "rgba(255, 68, 68, 0.1)",
                padding: "10px",
                borderRadius: "8px",
              }}
            >
              {error}
            </div>
          )}

          <div className="form-group">
            <label>{t("bot_details.updates.modal.version_label")}</label>
            <input type="text" placeholder="ex: v1.0.0" value={version} onChange={(e) => setVersion(e.target.value)} className="form-control" style={{ color: "white" }} />
          </div>

          <div className="form-group">
            <label>{t("bot_details.updates.modal.title_label")}</label>
            <input
              type="text"
              placeholder={t("bot_details.updates.modal.title_placeholder")}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="form-control"
              style={{ color: "white" }}
            />
          </div>

          <div className="form-group">
            <label>{t("bot_details.updates.modal.type_label")}</label>
            <select value={type} onChange={(e) => setType(e.target.value)} className="form-control" style={{ color: "white" }}>
              <option value="feature">{t("bot_details.updates.types.feature")}</option>
              <option value="bugfix">{t("bot_details.updates.types.bugfix")}</option>
              <option value="improvement">{t("bot_details.updates.types.improvement")}</option>
              <option value="security">{t("bot_details.updates.types.security")}</option>
              <option value="maintenance">{t("bot_details.updates.types.maintenance")}</option>
            </select>
          </div>

          <div className="form-group">
            <label>{t("bot_details.updates.modal.description_label")} (Markdown)</label>
            <textarea
              style={{ color: "white" }}
              placeholder={t("bot_details.updates.modal.description_placeholder")}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="form-control"
              rows="6"
            ></textarea>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-danger" onClick={onClose} disabled={loading}>
              {t("bot_details.updates.modal.cancel")}
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? t("bot_details.updates.modal.posting") : editingUpdate ? t("bot_details.updates.modal.save") : t("bot_details.updates.modal.post")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UpdateBotModal;
